/** Stores all the names of the mql dictionaries */
class MqlDictionaryNames {
}
MqlDictionaryNames.badCompany = 'bad-company';
MqlDictionaryNames.badPhoneNumber = 'bad-phone-number';
MqlDictionaryNames.blacklistedEmail = 'blacklisted-email';
MqlDictionaryNames.competitorEmail = 'competitor-email';
MqlDictionaryNames.desirableEmail = 'desirable-email';
MqlDictionaryNames.disposableEmail = 'disposable-email';
MqlDictionaryNames.hobbyistJobTitle = 'hobbyist-job-title';
MqlDictionaryNames.junkJobTitle = 'junk-job-title';
MqlDictionaryNames.profanity = 'profanity';
MqlDictionaryNames.studentJobTitle = 'student-job-title';
MqlDictionaryNames.getAllNames = () => [
    MqlDictionaryNames.badCompany,
    MqlDictionaryNames.badPhoneNumber,
    MqlDictionaryNames.blacklistedEmail,
    MqlDictionaryNames.competitorEmail,
    MqlDictionaryNames.desirableEmail,
    MqlDictionaryNames.disposableEmail,
    MqlDictionaryNames.hobbyistJobTitle,
    MqlDictionaryNames.junkJobTitle,
    MqlDictionaryNames.profanity,
    MqlDictionaryNames.studentJobTitle,
];
export default MqlDictionaryNames;
